import api from './client'

export interface LoginDto { email: string; password: string }
export interface ChangePasswordDto { currentPassword: string; newPassword: string }

export interface AuthUser {
  id: string
  email: string
  firstName: string
  lastName: string
  role: string
  companyId: string | null
  canSeePhone?: boolean
  canSeeEmail?: boolean
  canEditServicePrices?: boolean
}

export const authApi = {
  login: (dto: LoginDto) => api.post<{ accessToken: string; user: AuthUser }>('/auth/login', dto),
  me: () => api.get<AuthUser>('/auth/me'),
  updateMe: (dto: { firstName?: string; lastName?: string; email?: string; avatarUrl?: string }) =>
    api.patch<AuthUser>('/auth/me', dto),
  logout: () => api.post('/auth/logout'),
  changePassword: (dto: ChangePasswordDto) => api.post('/auth/change-password', dto),
  forgotPassword: (email: string) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token: string, newPassword: string) =>
    api.post('/auth/reset-password', { token, newPassword }),
  validateResetToken: (token: string) =>
    api.post<{ valid: boolean }>('/auth/validate-reset-token', { token }),
  validateInviteToken: (token: string) =>
    api.post<{ valid: boolean }>('/auth/validate-invite-token', { token }),
  acceptInvite: (token: string, newPassword: string) =>
    api.post('/auth/accept-invite', { token, newPassword }),
}
